/** @jsx jsx */
import { jsx } from 'theme-ui';

export const Banner = (props) => (
  <div
    sx={{
      pb: 3,
      ul: {
        listStyle: 'none',
        display: 'flex',
        flexWrap: 'wrap',
        p: 0,
        m: 0,
      },
      li: {
        mr: 3,
      },
      a: {
        color: 'inherit',
        textDecoration: 'none',
      },
    }}
  >
    {props.children}
  </div>
);

export const Container = ({ wide, ...props }) => (
  <div
    sx={{
      maxWidth: 'container',
    }}
  >
    {props.children}
  </div>
);

export const Tiles = (props) => (
  <div
    sx={{
      ul: {
        listStyle: 'none',
        p: 0,
        m: 0,
        display: 'grid',
        gridGap: 3,
        gridTemplateColumns: 'repeat(auto-fit, minmax(256px, 1fr))',
      },
      h2: {
        fontSize: 2,
      },
      img: {
        display: 'block',
        width: 128,
        maxWidth: '100%',
        height: 'auto',
        m: 'auto',
      },
      a: {
        variant: 'styles.navlink',
      },
      h3: {
        my: 1,
      },
      ...props.sx,
    }}
  >
    {props.children}
  </div>
);

export const List = (props) => (
  <div
    sx={{
      ul: {
        p: 0,
        m: 0,
        listStyle: 'none',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(256px, 1fr))',
        gridGap: 4,
      },
      a: {
        variant: 'styles.navlink',
        fontWeight: 'bold',
      },
      py: 1,
      fontSize: 1,
    }}
  >
    {props.children}
  </div>
);

export const CardWrapper = (props) => (
  <div
    sx={{
      p: 0,
      mt: 4,
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
    }}
  >
    {props.children}
  </div>
);

export const Card = (props) => (
  <div
    sx={{
      py: 1,
    }}
    {...props}
  >
    {props.children}
  </div>
);
